<script lang="ts">
  import { categoriesQuery } from '$lib/queries/products';

  // Read-only — categories are synced from ProQuote.
  const categories = categoriesQuery();
</script>

<div>
  <table class="text-center min-w-full divide-y divide-blue-100">
    <thead class="bg-blue-50">
      <tr>
        <th>Name</th>
        <th>Description</th>
      </tr>
    </thead>
    <tbody>
      {#each categories.data ?? [] as category}
        <tr>
          <td>{category.name}</td>
          <td>{category.description}</td>
        </tr>
      {/each}
    </tbody>
  </table>
</div>
